import { render, staticRenderFns } from "./index-admin.vue?vue&type=template&id=4605fba8&scoped=true"
import script from "./index-admin.vue?vue&type=script&lang=js"
export * from "./index-admin.vue?vue&type=script&lang=js"
import style0 from "./index-admin.vue?vue&type=style&index=0&id=4605fba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605fba8",
  null
  
)

export default component.exports